import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EventsWebsocketService } from '../../../services/entities/events-websocket.service';
import { EventsBlueprint } from './events-blueprint';
import { entityActions } from 'src/app/state/entities/entity.actions';
import { EntityType, Components, CollisionType } from 'src/app/state/entities/entity.model';
import { Vector3 } from 'three';
import { flyers } from '../../world/blueprints/flyer/flyer.service';

@Injectable({
  providedIn: 'root'
})
export class TestSpiralMakerService extends EventsBlueprint {
  override prompt = "spiral"
  intervalTimer = null;
  incrementer = 0;
  flyers: string[] = [];
  constructor(
    private store: Store,
    private websocketService: EventsWebsocketService,
  ) {
    super()
  }

  override start(): void {
    setTimeout(() => {
      this.intervalTimer = setInterval(this.every5s.bind(this), 5);
    }, 5000);
  }


  every5s() {
    const amount = 500;
    if (this.incrementer > amount) {
      clearInterval(this.intervalTimer);
      this.intervalTimer = setInterval(this.moveSomething.bind(this), 0);
      return;
    }
    this.incrementer = this.incrementer + 1;
    this.flyers.push(this.incrementer + "");
    this.websocketService.dispatch(
      entityActions.netCreated({
        entity: {
          id: this.incrementer + "",
          type: EntityType.Flyer,
          ownerId: "self",
          components: [Components.text],
          componentProperties: { Text: `TEst card ${this.incrementer}` },
          coord: this.spiralCoordinate(this.incrementer, amount),
          collisionType: CollisionType.Obstacle,
          creationDate: new Date(),
        },
      }),
    );
  }


  moveSomething() {
    for (let i = 0; i < 1; i++) {
      this.initMove(i % 500);
    }
  }

  initMove(index) {
    const flyerId = this.flyers.at(index);
    const flyer = flyers.get(flyerId);
    const pos = new Vector3();
    pos.copy(flyer.entity.coord);
    const newPos = new Vector3();
    newPos.copy(pos);
    const amount = 3;
    newPos.x += Math.random() * amount - amount / 2;
    newPos.y += Math.random() * amount - amount / 2;
    this.websocketService.dispatch(
      entityActions.netMoved({
        entityId: flyerId,
        oldPos: pos,
        newPos: newPos,
      }),
    );
  }

  spiralCoordinate(index, maxIndex = 1000) {
    // Define the maximum radius of the spiral
    const maxRadius = 100; // Adjust this to control the size of the spiral
    const loops = 30;

    // Calculate the angle and radius for the given index
    const angle = (index / maxIndex) * 2 * Math.PI * loops; // Controls the spiral tightness
    const radius = 2 + maxRadius * (1 - index / maxIndex); // Moves from outside to inside

    // Convert polar coordinates (angle, radius) to Cartesian (x, y)
    const x = radius * Math.cos(angle);
    const y = radius * Math.sin(angle);

    return new Vector3(x, y, Math.random() * 100);
  }
}
